import { Link } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'
import { LANDING_ROUTE } from '@/config/roles'
import { PageContainer, EmptyState } from '@/design'

/** Rendered by RequireRole when the user's role is not permitted for a route. */
export function Forbidden() {
  const user = useAuthStore((s) => s.user)
  const home = user ? LANDING_ROUTE[user.role] : '/login'
  return (
    <PageContainer>
      <EmptyState
        icon={ShieldAlert}
        title="You don't have access to this page"
        message="Your role doesn't permit this section. If you think this is a mistake, contact a platform administrator."
        action={
          <Link to={home} className="mt-1 rounded-md bg-primary px-4 py-2 text-title-sm font-semibold text-white hover:shadow-md">
            Go to my home
          </Link>
        }
      />
    </PageContainer>
  )
}
